import { Component, OnInit } from '@angular/core';
import { SessionService } from 'app/components/common/session/session.service';
import { UsersService } from 'app/components/users/users.service';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-recovery-password',
  templateUrl: './modal-recovery-password.component.html',
  styleUrls: ['./modal-recovery-password.component.css']
})
export class ModalRecoveryPasswordComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  username: string = '';
  eventData: object = {};

  constructor(private sessionService: SessionService, private usersService: UsersService, private ngbActiveModal: NgbActiveModal, public translateService: TranslateService) { }

  cancel(){
    this.ngbActiveModal.close();
  }


  recoveryPassword(recoveryPasswordIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.usersService.recoveryPassword(recoveryPasswordIn)
      .subscribe((data: object) => {
        this.recoveryPasswordOk(data);
      },
        error => {
          this.recoveryPasswordError(error);
        });

  }

  recoveryPasswordOk(data) {

    this.loader.count--;
    this.alertMessage = 'MODAL_RECOVERY_PASSWORD.OK_MESSAGE';

  }

  recoveryPasswordError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  recoveryPasswordBtn() {

    let recoveryPasswordIn = {
      email: this.username,
      accountId: this.eventData['accountId'],
      event: this.eventData['sapCode'],
      redirectUrl: '',
      language: this.translateService.currentLang
    }

    this.recoveryPassword(recoveryPasswordIn);

  }


  ngOnInit() {
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
  }

}
